import axios from "axios";
import Cookies from "universal-cookie";
import { domain } from "./urls";

const cookies = new Cookies();

// Create axios interceptor for response
axios.interceptors.response.use(
  (response) => {
    // Return successful responses as is
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      cookies.remove("auth_token", { path: "/", domain: domain });
      cookies.remove("user_role", { path: "/", domain: domain });
      cookies.remove("user_id", { path: "/", domain: domain });
      cookies.remove("partner_utm_source", { path: "/", domain: domain });
      cookies.remove("partner_utm_medium", { path: "/", domain: domain });

      window.location.href = "/login";
    }

    // Return the error for other status codes
    return Promise.reject(error);
  }
);

export default axios;
